import React from 'react';
import * as Sentry from '@sentry/react';

import MDX from '../../components/MDX';
import {lessonComponents} from '../../components/lesson';

const reportCompileError = (e) => {
  // eslint-disable-next-line no-console
  console.error('Lesson MDX failed to compile:', e);
  Sentry.captureException(e, {tags: {mdxComponent: 'LessonMarkdown'}});
};

const LessonMarkdown = ({children, components, ...props}) => (
  <MDX
    className="prose lesson-prose"
    components={{...lessonComponents, ...(components || {})}}
    onError={reportCompileError}
    {...props}
  >
    {children}
  </MDX>
);

export default LessonMarkdown;
